import { render, staticRenderFns } from "./DiscountsDebugpage.vue?vue&type=template&id=2b6ed3f4&scoped=true"
import script from "./DiscountsDebugpage.vue?vue&type=script&lang=js"
export * from "./DiscountsDebugpage.vue?vue&type=script&lang=js"
import style0 from "./DiscountsDebugpage.vue?vue&type=style&index=0&id=2b6ed3f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6ed3f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Filati\\filatiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b6ed3f4')) {
      api.createRecord('2b6ed3f4', component.options)
    } else {
      api.reload('2b6ed3f4', component.options)
    }
    module.hot.accept("./DiscountsDebugpage.vue?vue&type=template&id=2b6ed3f4&scoped=true", function () {
      api.rerender('2b6ed3f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/discounts/DiscountsDebugpage.vue"
export default component.exports